import React, { useEffect, useState } from "react";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import { Button, Col, Form, Row } from "react-bootstrap";
import * as icons from "react-bootstrap-icons";
import { ModalBox } from "../Outer/Modal";
import {
  SportAll,
  SportAllMap,
  SportAllSearch,
  SportDelete,
  SportsReg,
  SportsUpdate,
} from "../../redux/auth-reducer/auth-service";
import DataTable from "react-data-table-component";
import { Footer } from "../../Footer";
import { ToastContainer, toast } from "react-toastify";
import { useImageUpload } from "../../hooks/useImageUpload";
import { ImageUrl } from "../../utils/config/config";
import { readApiMessage } from "../../utils/helper/helper";
import { IMAGE_STILL_UPLOADING } from "../../utils/helper/imageUpload";
import { SportFormFields } from "./SportFormFields";
import { FormActions } from "./FormActions";
import { ConfirmDeleteModal } from "./ConfirmDeleteModal";

// Action column buttons. A row the caller cannot manage gets the same classes plus "disabled".
const DELETE_BUTTON_CLASS = "text-danger btn-aucion ms-1";
const EDIT_BUTTON_CLASS = "text-success btn-aucion ms-1";

// The logo a sport without its own image shows, in the list and in Update Sport.
const SPORT_ICON = "../image/sport-icon.png";

export const Sports = () => {
  const [data, setData] = useState();
  const [show, setShow] = useState(false);
  const [validated, setValidated] = useState(false);
  const [editValidated, setEditValidated] = useState(false);
  const [itemList, setItemList] = useState("");
  // #10: the image each form saves. See useImageUpload for what a failed upload does.
  const addIcon = useImageUpload();
  const editIcon = useImageUpload();
  const [count, setCount] = useState(0);
  const [deleteRow, setDeleteRow] = useState(null);
  const [pageSize, setPageSize] = useState();
  const [searchText, setSearchText] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [isBracket, setIsBracket] = useState(false);
  const [bracket, setBracket] = useState();
  const [totalRows, setTotalRows] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [err, setErr] = useState(false);
  const pageOptions = [10, 20, 30, 50];
  const [editData, setEditData] = useState({
    sportImage: "",
    sportName: "",
    sportId: 0,
  });
  const [sportReg, setSportReg] = useState({
    sportName: "",
    sportImage: null,
    sportId: "",
  });

  function sidebarfun() {
    setData(!data);
  }
  // #10: an image uploaded and then cancelled used to stay behind and be saved with the next sport.
  // #306: so did the name, now that the field shows what the form will send, and the red outlines of
  // a refused save.
  const AddSport = () => {
    addIcon.reset();
    setSportReg({ sportName: "", sportImage: null, sportId: "" });
    setValidated(false);
    setErr("");
    setShow(true);
  };
  const handleClosed = (e) => {
    setShowModal(false);
    setShow(false);
    setShowModalEdit(false);
  };

  const handelSport = (e) => {
    setSportReg({ ...sportReg, [e.target.name]: e.target.value });

    if (e.target.value.length === 50) {
      setErr(true);
    } else {
      setErr("");
    }
  };

  useEffect(() => {
    setBracket(editData.isBracket);
  }, [editData]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setValidated(true);
    // #306: an invalid form (no name) is refused here, as on Add Team; it used to be sent anyway and
    // refused by the server.
    if (event.currentTarget.checkValidity() === false) {
      event.stopPropagation();
      return;
    }
    // #10: this used to test `imageResponse?.status == false` - the HTTP status, never false - so a
    // failed upload still saved the sport without its image. useImageUpload never takes a failed
    // upload's name, so only an upload still on its way has to be waited for.
    if (addIcon.uploading) {
      toast.error(IMAGE_STILL_UPLOADING);
      return;
    }
    const registerData = [
      {
        sportId: 0,
        sportName: sportReg.sportName,
        sportImage: addIcon.name || null,
        // "userId": 2,
        isBracket: isBracket,
      },
    ];

    await SportsReg(registerData).then((res) => {
      if (res?.data?.status == true) {
        setCount(count + 1);
        setShow(false);
        toast.success(res?.data?.message);
        setValidated(false);
        addIcon.reset();
        setSportReg({
          sportsName: "",
          sportImage: null,
          sportsId: "",
          userId: 0,
        });
      } else {
        toast.error(res?.data?.message);
      }
    });
  };

  // Function to fetch data from API
  const SportAllFn = async (data) => {
    try {
      const response = await SportAll(data); // Call your API function
      if (response?.data) {
        setItemList(response.data.data.dataList || []); // Set the item list
        setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Effect to fetch data when current page changes
  useEffect(() => {
    const data = {
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: false,
    };
    SportAllFn(data); // Fetch data when currentPage changes
  }, [currentPage, count]); // Dependency on currentPage

  const handlePerPageChange = (event) => {
    const newPerPage = Number(event.target.value);
    const data = {
      PageNumber: currentPage,
      PageSize: newPerPage,
      SortOrder: false,
    };
    SportAllFn(data);

    setPerPage(newPerPage); // Update items per page
    setCurrentPage(1); // Reset to first page when items per page changes
  };

  // Handle page change
  const handleNextPage = () => {
    if (currentPage < Math.ceil(totalRows)) {
      setCurrentPage((prevPage) => prevPage + 1); // Go to next page
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1); // Go to previous page
    }
  };

  const columns = [
    {
      name: <strong>Id</strong>,
      selector: (row, index) => (currentPage - 1) * perPage + index + 1,

      width: "80px",
    },

    {
      name: <strong>Logo</strong>,
      selector: (row) => (
        <>
          {row.sportImage == null || row.sportImage == "" ? (
            <img
              src={SPORT_ICON}
              width={50}
              className="img-fluid pt-3 pb-3"
            />
          ) : (
            <img
              src={ImageUrl + row?.sportImage}
              width={50}
              className="img-fluid pt-3 pb-3"
            ></img>
          )}
        </>
      ),
    },
    {
      name: <strong>Sport Name</strong>,
      selector: (row) => row?.sportName,
      sortable: true,
    },

    {
      name: <strong>Action</strong>,
      // canEdit comes from usp_GetAllSportsData, which computes it from the same ownership rule
      // usp_CRUDSports and usp_DeleteSportsById enforce. Shared sports (a Web Admin's and the
      // practice manager's) are listed for every manager but only the practice manager may edit
      // or delete them. Every row used to offer Edit and Delete unconditionally. Disabled rather
      // than hidden, matching Team.js.
      selector: (row) => (
        <>
          <button
            type="button"
            disabled={!row?.canEdit}
            className={
              row?.canEdit
                ? DELETE_BUTTON_CLASS
                : `${DELETE_BUTTON_CLASS} disabled`
            }
            onClick={() => deleteFn(row)}
          >
            <icons.Trash />
          </button>
          <button
            type="button"
            disabled={!row?.canEdit}
            className={
              row?.canEdit
                ? EDIT_BUTTON_CLASS
                : `${EDIT_BUTTON_CLASS} disabled`
            }
            onClick={() => edit(row)}
          >
            <icons.PencilSquare />
          </button>
        </>
      ),
      width: "200px",
    },
  ];

  const handelEditSport = (e) => {
    setEditData({ ...editData, [e.target.name]: e.target.value });
    if (e.target.value.length === 50) {
      setErr(true);
    } else {
      setErr("");
    }
  };
  // Batch 4.1: bracket system disabled - its only callers were the two checkboxes below.
  // const handelBracket = (event) => {
  //   setIsBracket(event.target.checked);
  // };

  const edit = async (edititem) => {
    setShowModalEdit(true);
    setEditValidated(false);
    setErr("");

    setEditData(edititem);
    editIcon.reset(edititem?.sportImage);
  };

  // #307: the whole row, so the confirmation can name the sport.
  const deleteFn = async (row) => {
    setDeleteRow(row);
    setShowModal(!showModal);
  };

  const update = async (event) => {
    event.preventDefault();
    // #306: the update form validates like Add's; it had no form at all, so a cleared name was sent.
    if (event.currentTarget.checkValidity() === false) {
      event.stopPropagation();
      setEditValidated(true);
      return;
    }
    // Batch 4.1 (#82/#84): send the edited sport's OWN flag, not the create-form `isBracket`
    // state (which defaults to false and is not what the edit modal binds to - that is
    // `bracket`, set from editData at mount). usp_CRUDSports does `TRG.IsBracket = SRC.IsBracket`
    // unconditionally, so the old payload silently turned an existing bracket sport into a
    // no-bracket one on any rename or image change, and the next contest save would then rebuild
    // that contest into tblTournamentNoBrackets. Existing bracket contests must be left as they
    // are, so the flag has to survive an edit. Previously: isBracket: isBracket.
    if (editIcon.uploading) {
      toast.error(IMAGE_STILL_UPLOADING);
      return;
    }
    // #10: the sport's current image unless a new one was uploaded; a failed upload keeps it.
    const registerData = {
      sportId: editData?.sportId,
      sportName: editData?.sportName,
      sportImage: editIcon.name || null,

      isBracket: editData?.isBracket,
    };

    await SportsUpdate(registerData).then((res) => {
      if (res?.status == true) {
        setCount(count + 1);
        setShowModalEdit(false);
        setEditValidated(false);
        toast.success(res?.message);
      } else {
        toast.error(res?.message);
      }
    });
  };

  // #307: the server's own sentence, "Sport deleted successfully.", as Team, Auction and Contest show
  // theirs; a refusal keeps the dialog open, as theirs do.
  const handelDelete = async () => {
    await SportDelete(deleteRow?.sportId).then((res) => {
      if (res?.status == true) {
        setShowModal(!showModal);
        setCount(count + 1);
        toast.success(res?.message);
      } else {
        toast.error(readApiMessage(res));
      }
    });
  };

  const SportAllFnSearch = async (data) => {
    try {
      const response = await SportAllSearch(data); // Call your API function
      if (response?.data) {
        setItemList(response.data.data.dataList || []); // Set the item list
        setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    if (value.length === 1 && value === " ") {
      return; // Ignore the input if it's just a space
    }
    setSearchText(value);
    const data = {
      SearchTerm: value,
      SortOrder: false,
      SortColumn: "sportName",
    };
    SportAllFnSearch(data);
  };

  const filteredData = searchText
    ? itemList.filter((item) => {
        return item.sportName.toLowerCase().includes(searchText.toLowerCase());
      })
    : itemList;

  const clearSearch = () => {
    const data = {
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: false,
    };
    SportAllFn(data);
    setSearchText("");
  };

  return (
    <>
      <ModalBox
        show={showModalEdit}
        onHide={handleClosed}
        title="Update Sport"
        body={
          // #306: the same fields and layout as Add Sport (SportFormFields).
          <Form noValidate validated={editValidated} onSubmit={update}>
            {/* #10: the image the update will save, not the file picked: an upload that failed
                leaves the current one. */}
            <SportFormFields
              idPrefix="edit-sport"
              values={editData}
              onChange={handelEditSport}
              nameTooLong={Boolean(err)}
              image={editIcon}
              placeholderImage={SPORT_ICON}
            />

            {/*
              Batch 4.1 (#82 MG-008, #84 AD-008): bracket system disabled, so the edit modal no
              longer mentions brackets. This block was read-only already (disabled checkbox); the
              flag itself is preserved on save - see the note in update() above.

            <Form.Group>
              <label className="d-flex  mt-3">
                {editData.isBracket === true ? (
                  <>
                    <input
                      type="checkbox"
                      className="inputCheck"
                      onClick={handelBracket}
                      name="isBracket"
                      checked={bracket}
                      disabled={true}
                    />
                    <p>There is Bracket in this Sport.</p>
                  </>
                ) : (
                  "There is no Bracket in this Sport."
                )}
              </label>
            </Form.Group>
            */}
            <FormActions onCancel={handleClosed} submitLabel="Update" />
          </Form>
        }
      />

      <ConfirmDeleteModal
        show={showModal}
        entity="sport"
        name={deleteRow?.sportName}
        onConfirm={handelDelete}
        onCancel={handleClosed}
      />

      <ModalBox
        show={show}
        onHide={handleClosed}
        title="Add Sport"
        body={
          <>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <SportFormFields
                idPrefix="add-sport"
                values={sportReg}
                onChange={handelSport}
                nameTooLong={Boolean(err)}
                image={addIcon}
              />
              {/*
                  Batch 4.1 (#82 MG-008, #84 AD-008): bracket system disabled, so no new sport can
                  be flagged as a bracket sport. The `isBracket` state stays at its default of
                  false and is still sent in the create payload - it must keep being sent
                  explicitly, because tblSports.IsBracket has a DEFAULT of 1, so dropping the
                  field would create bracket sports instead of preventing them.

                <Form.Group>
                  <label className="d-flex  mt-3">
                    <input
                      type="checkbox"
                      className="inputCheck"
                      onClick={handelBracket}
                      name="isBracket"
                      value={isBracket}
                    />
                    Do you want to add contest bracket.
                  </label>
                </Form.Group>
                */}
              <FormActions onCancel={handleClosed} />
            </Form>
          </>
        }
      />

      <TopNavbar sidebarfun={sidebarfun} />
      <div className="dasboard-group">
        <Sidebar data={data} />
        <div
          className={
            data ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <Row>
            <Col md={6}>
              <h1 className="heading-dash">Sports</h1>
            </Col>
            <Col md={6} className="text-right">
              <Button
                className="primary button-create-auction btn btn-primary "
                onClick={AddSport}
              >
                <icons.Plus class="icon-plus" /> Add Sport
              </Button>
            </Col>
          </Row>

          <div className="group_data_table sport">
            {/* <div className='search-input d-flex align-items-center'>
                            <input type="text" className='form-control mb-3 mt-3' placeholder="Search..." value={searchText} onChange={handleSearch} />
                        </div> */}
            <div className="search-input d-flex align-items-center">
              <input
                type="text"
                className="form-control mb-3 mt-3"
                placeholder="Search..."
                value={searchText}
                onChange={handleSearch}
              />
              {searchText && (
                <button className="btn btn-clear" onClick={clearSearch}>
                  <span>&times;</span> {/* This represents the close icon */}
                </button>
              )}
            </div>
            <div>
              <DataTable
                title="Sport List"
                columns={columns}
                data={filteredData}
                paginationPerPage={perPage}
                paginationTotalRows={totalRows * 10}
                paginationDefaultPage={currentPage}
                onChangePage={setCurrentPage}
              />
              {totalRows > 1 && (
                <Row>
                  <Col md={12} className="text-right">
                    <div className="pagination-controls">
                      {totalRows > 1 ? (
                        <>
                          <label>Rows per page: </label>{" "}
                          <select
                            id="itemsPerPage"
                            value={perPage}
                            onChange={handlePerPageChange}
                          >
                            {pageOptions.map((option) => (
                              <option key={option} value={option}>
                                {option}
                              </option>
                            ))}
                          </select>
                        </>
                      ) : (
                        ""
                      )}

                      <Button
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                      >
                        <icons.ArrowLeft></icons.ArrowLeft>
                      </Button>
                      <span>
                        {" "}
                        {currentPage} of {totalRows}{" "}
                      </span>
                      <Button
                        onClick={handleNextPage}
                        disabled={currentPage >= Math.ceil(totalRows)}
                      >
                        <icons.ArrowRight></icons.ArrowRight>
                      </Button>
                    </div>
                  </Col>
                </Row>
              )}
            </div>
          </div>
        </div>
        <div className={data ? "footer" : "footer-content"}>
          <Footer />
        </div>
      </div>
    </>
  );
};
